import { LivePlaysService } from '../generated-api';
import type { LivePlayEvent, LivePlayUpdateInput } from '../generated-api';

/**
 * Send metadata updates to a LivePlay session.
 * This function handles the event creation and sending, abstracting away
 * the event-based API from components that just want to update metadata.
 * 
 * @param livePlayId - The ID of the live play session
 * @param metadata - Metadata object with structure: { teamName: { fieldName: value, ... }, ... }
 */
export async function sendLivePlayMetadataUpdates(
  livePlayId: string,
  metadata: Record<string, Record<string, any>>
): Promise<void> {
  const now = new Date();
  const eventsToSend: LivePlayEvent[] = [];
  
  // Build events from metadata object
  Object.entries(metadata).forEach(([teamName, fields]) => {
    Object.entries(fields).forEach(([fieldName, value]) => {
      eventsToSend.push({
        timestamp: now.toISOString(),
        eventType: 'metadata_update',
        teamName: teamName,
        fieldName: fieldName,
        value: value,
      });
    });
  });
  
  // Send all events sequentially
  for (const event of eventsToSend) {
    const updateInput: LivePlayUpdateInput = { event };
    await LivePlaysService.updateLivePlayLivePlaysLivePlayIdPatch({
      livePlayId: livePlayId,
      requestBody: updateInput,
    });
  }
}
